"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _default(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      rotate = _ref.rotate,
      className = _ref.className,
      _ref$dataTestid = _ref['data-testid'],
      dataTestId = _ref$dataTestid === void 0 ? 'icon' : _ref$dataTestid;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " icon icon--chevron fill-").concat(color),
    style: {
      width: "".concat(width, "px"),
      transform: "rotate(".concat(rotate, "deg)"),
      height: "".concat(height, "px")
    },
    viewBox: "0 0 40 23",
    "data-testid": dataTestId
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.982 22.894c-.544 0-1.177-.64-1.766-1.071L.638 3.829c-.815-1.18-.886-2.235 0-3.149.886-.914 2.25-.9 3.15 0l16.194 16.195L36.176.68c.9-.9 2.25-.9 3.15 0 .899.9.899 2.25 0 3.149L21.61 21.823c-.461.447-1.085 1.071-1.628 1.071z"
  }));
}